import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import { useAppConfig } from '../appConfig/AppConfig';

/* istanbul ignore next */
const styles = ({ palette: { background }, spacing: { unit } }) => ({
  appInfo: {
    background,
    bottom: 0,
    borderRadius: unit / 2,
    boxShadow: `${unit / 8}px ${unit / 8}px ${unit / '.8'}px ${0}px rgba(0,0,0,.2)`,
    display: 'flex',
    flexDirection: 'column',
    padding: unit * 2,
    position: 'fixed',
    right: 0
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  cell: {
    margin: 0,
    padding: unit / 2
  }
});

export const KEYS = Object.freeze({
  BACK_TICK: '`',
  BACK_TICK_CODE: 192,
  ESCAPE: 'Escape',
  ESCAPE_SHORT: 'Esc',
  ESCAPE_CODE: 27
});

export const BITBUCKET_URL = 'https://bitbucket.bottomline.tech/projects/CB/repos/cbe-ui';
export const CHANGELOG_URL = `${BITBUCKET_URL}/browse/CHANGELOG.md`;
export const COMMIT_URL = `${BITBUCKET_URL}/commits`;

export function AppInfoComponent({ children, classes }) {
  const {
    REACT_APP_BUILD_NUMBER = 'missing',
    REACT_APP_BUILD_URL = '',
    REACT_APP_GIT_COMMIT = 'missing',
    isProduction,
    version
  } = useAppConfig();
  const [show, setShow] = useState(false);

  const handleEvent = (e) => {
    const magicalKeyPress =
      e.altKey && e.shiftKey && (e.key === KEYS.BACK_TICK || e.keyCode === KEYS.BACK_TICK_CODE);
    if (magicalKeyPress) {
      setShow((show) => !show);
    }
    if (e.key === KEYS.ESCAPE || e.key === KEYS.ESCAPE_SHORT || e.keyCode === KEYS.ESCAPE_CODE) {
      setShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keyup', handleEvent);
    return () => {
      window.removeEventListener('keyup', handleEvent);
    };
  }, []);

  return (
    <>
      {children}
      {show && !isProduction && (
        <aside className={classes.appInfo}>
          <div className={classes.row}>
            <p className={classes.cell}>NPM Version:</p>
            <p className={classes.cell}>
              <a
                data-qa="change-log-url"
                href={`${CHANGELOG_URL}?at=v${version}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {version}
              </a>
            </p>
          </div>
          <div className={classes.row}>
            <p className={classes.cell}>Build Number:</p>
            <p className={classes.cell}>{REACT_APP_BUILD_NUMBER}</p>
          </div>
          <div className={classes.row}>
            <p className={classes.cell}>Build URL:</p>
            <p className={classes.cell}>
              <a
                data-qa="build-url"
                href={REACT_APP_BUILD_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                build
              </a>
            </p>
          </div>
          <div className={classes.row}>
            <p className={classes.cell}>Commit:</p>
            <p className={classes.cell}>
              <a
                data-qa="commit-url"
                href={`${COMMIT_URL}/${REACT_APP_GIT_COMMIT}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {REACT_APP_GIT_COMMIT}
              </a>
            </p>
          </div>
        </aside>
      )}
    </>
  );
}

AppInfoComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
  classes: PropTypes.shape({})
};

AppInfoComponent.defaultProps = {
  children: null,
  classes: {}
};

const Styled = withStyles(styles)(AppInfoComponent);
export default Styled;
